import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function TermAndCondition() {
  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen">
      <Navbar />
      <div className="px-4 sm:px-8 md:px-12 lg:px-24 xl:px-40 pt-12 pb-20">
        <div className="flex flex-col gap-8">
          <div className="w-full">
            <div className="bg-white rounded-[20px] pb-12 shadow-sm">
              <div className="text-2xl md:text-3xl font-medium py-8 px-6 lg:px-12 text-text-secondary border-b border-gray-100">
                Terms & Condition
              </div>

              <div className="px-6 lg:px-12 pt-8 space-y-8 text-text-secondary leading-relaxed text-base">
                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3 uppercase tracking-wide">
                    OVERVIEW
                  </p>
                  <div className="space-y-4">
                    <p>
                      Welcome to isancharr.com, operated by Isancharr.
                      Throughout the site, the terms “we,” “us,” and “our” refer
                      to Isancharr. Isancharr offers this website, including all
                      information, tools, and services available from this site
                      to you, the user, conditioned upon your acceptance of all
                      terms, conditions, policies, and notices stated here.
                    </p>
                    <p>
                      By visiting our site and/or purchasing something from us,
                      you engage in our “Service” and agree to be bound by the
                      following terms and conditions (“Terms of Service” or
                      “Terms”), including those additional terms, conditions,
                      and policies referenced herein and/or available by
                      hyperlink.
                    </p>
                    <p>
                      Please read these Terms of Service carefully before
                      accessing or using our website. By accessing or using any
                      part of the site, you agree to be bound by these Terms of
                      Service. If you do not agree to all the terms and
                      conditions of this agreement, you may not access the
                      website or use any services.
                    </p>
                  </div>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Online Store Terms
                  </p>
                  <p>
                    By agreeing to these Terms of Service, you represent that
                    you are at least the age of majority in your state or
                    province of residence, or that you are the age of majority
                    in your state or province of residence and have given us
                    your consent to allow any of your minor dependents to use
                    this site. You may not use our products for any illegal or
                    unauthorized purpose, nor may you, in the use of the
                    Service, violate any laws in your jurisdiction (including
                    but not limited to copyright laws).
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    General Conditions
                  </p>
                  <p>
                    We reserve the right to refuse service to anyone for any
                    reason at any time. You understand that your content
                    (excluding credit card information) may be transferred
                    unencrypted and involve (a) transmissions over various
                    networks; and (b) changes to conform and adapt to the
                    technical requirements of connecting networks or devices.
                    Credit card information is always encrypted during transfer
                    over networks.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Accuracy, Completeness, and Timeliness of Information
                  </p>
                  <p>
                    We are not responsible if the information made available on
                    this site is not accurate, complete, or current. The
                    material on this site is provided for general information
                    only and should not be relied upon or used as the sole basis
                    for making decisions without consulting primary, more
                    accurate, more complete, or more timely sources of
                    information.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Modifications to the Service and Prices
                  </p>
                  <p>
                    Prices for our products are subject to change without
                    notice. We reserve the right at any time to modify or
                    discontinue the Service (or any part or content thereof)
                    without notice. We shall not be liable to you or any third
                    party for any modification, price change, suspension, or
                    discontinuance of the Service.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Products or Services
                  </p>
                  <p>
                    Certain products or services may be available exclusively
                    online through the website. We have made every effort to
                    display as accurately as possible the colors and images of
                    our products that appear in the store. We reserve the right
                    but are not obligated to limit the sales of our products or
                    Services to any person, geographic region, or jurisdiction.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Accuracy of Billing and Account Information
                  </p>
                  <p>
                    We reserve the right to refuse any order you place with us.
                    You agree to provide current, complete, and accurate
                    purchase and account information for all purchases made at
                    our store. You agree to promptly update your account and
                    other information, including your email address and credit
                    card details, so that we can complete your transactions.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Third-Party Links
                  </p>
                  <p>
                    Certain content, products, and services available via our
                    Service may include materials from third parties.
                    Third-party links on this site may direct you to third-party
                    websites that are not affiliated with us. We are not liable
                    for any harm or damages related to the purchase or use of
                    goods, services, resources, content, or any other
                    transactions made in connection with any third-party
                    websites.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Disclaimer of Warranties; Limitation of Liability
                  </p>
                  <p>
                    We do not guarantee, represent, or warrant that your use of
                    our service will be uninterrupted, timely, secure, or
                    error-free. You expressly agree that your use of, or
                    inability to use, the service is at your sole risk. In no
                    case shall Isancharr be liable for any injury, loss, claim,
                    or any direct, indirect, incidental, or consequential
                    damages of any kind.
                  </p>
                </section>

                <section>
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Governing Law
                  </p>
                  <p>
                    These Terms of Service and any separate agreements whereby
                    we provide you Services shall be governed by and construed
                    in accordance with the laws of India.
                  </p>
                </section>

                <section className="bg-slate-50 p-6 rounded-xl border border-slate-100">
                  <p className="text-lg font-semibold text-heading-blue mb-3">
                    Contact Information
                  </p>
                  <p>
                    Questions about the Terms of Service should be sent to us at
                    <a
                      href="mailto:support@isancharr.com"
                      className="text-heading-blue font-medium hover:underline ml-1"
                    >
                      support@isancharr.com
                    </a>
                    .
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
